// extracted by mini-css-extract-plugin
module.exports = {"report_style_class":"EmbedReport_report_style_class__DPGCm","ReportBtn":"EmbedReport_ReportBtn__RIwTs"};